"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NESTED_SCHEMA_TYPES = exports.NestedSchemaField = void 0;
/* eslint-disable import/no-cycle */
var react_1 = __importDefault(require("react"));
var input_1 = require("../input");
var embedded_coverage_1 = require("./embedded-coverage");
function NestedSchemaField(_a) {
    var name = _a.name, schema = _a.schema, fieldPath = _a.fieldPath;
    var inputType = schema.inputType;
    if (inputType === 'embedded-coverage') {
        return react_1.default.createElement(embedded_coverage_1.EmbeddedCoverageField, { name: name, schema: schema, fieldPath: fieldPath });
    }
    if (inputType === 'nested-schema') {
        return react_1.default.createElement(input_1.SchemaInput, { name: name, schema: schema, currentPath: fieldPath + "." });
    }
    return null;
}
exports.NestedSchemaField = NestedSchemaField;
exports.NESTED_SCHEMA_TYPES = ['nested-schema', 'embedded-coverage'];
